<template>
<Teleport to="#vue-modal">
  <div :class="mainModalClass">
    <div class="modalShade" @click="hideModal"></div>
    <!--    {/* Modal content */}-->
    <div class="bg-white rounded-lg shadow-sm modalContent max-w-fit max-h-[80vh]">
      <!--    {/* Modal header */}-->
      <div
          class="modalHeader flex items-start justify-between p-4 border-solid border-t-0 border-x-0 border-b border-gray-200 rounded-t">
        <h3 class="text-gray-900 text-xl lg:text-2xl font-semibold mt-0 my-0">
          {{ title }}
        </h3>
        <div @click="hideModal"
             class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
             data-modal-toggle="default-modal">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
               xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"></path>
          </svg>
        </div>
      </div>
      <!--      {/* Modal body */}-->
      <div v-if="hasSlottedContent" class="modalBody p-4 py-2 space-y-6 overflow-y-auto">
        <slot/>
      </div>
      <!--  {/* Modal footer */}-->
      <div v-if="buttons" class="block space-x-2 items-center p-4 border-solid border-t border-x-0 border-b-0 border-gray-200 rounded-b">
        <button v-for="button in buttons" data-modal-toggle="default-modal" type="button" @click="$emit(button.action)"
          :class="button.styles || 'text-gray-500 bg-white float-right hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10'">
          {{ button.title }}
        </button>
      </div>
      <slot v-else name="buttons"></slot>
    </div>
  </div>
</Teleport>
</template>
<script>


export default {
  props: ['title', 'buttons', 'mainModalClass'],
  emits: {
    close: {},
  },
  computed: {
    hasSlottedContent() {
      return !!this.$slots.default;
    },
  },
  methods: {
    hideModal(){
      this.$emit('close')
    },
  },
}
</script>
